export default __webpack_public_path__ + "static/2-mission-recap-6a76505698cc26b6044b1cd217cc8136.png";